import { formatSqlCode } from '../../../CodeEditor/utils';
import { isRecord } from '../../utils';
import type { ToolInvocationEvent } from '../../types';

export type WarehouseQuerySample = {
  columns: string[];
  rows: Record<string, unknown>[];
  rowCount: number;
  returnedRows: number;
  truncated: boolean;
};

type Invocation = ToolInvocationEvent['toolInvocation'];

const isStringList = (value: unknown[]): value is string[] =>
  value.every((item) => typeof item === 'string');

export const displayWarehouseQuerySql = (
  args?: Record<string, unknown>,
): string => formatSqlCode(typeof args?.sql === 'string' ? args.sql : '');

export const readWarehouseQuerySample = (
  value: unknown,
): WarehouseQuerySample | null => {
  if (
    !isRecord(value) ||
    !Array.isArray(value.columns) ||
    !Array.isArray(value.rows) ||
    !isStringList(value.columns) ||
    !value.rows.every(isRecord) ||
    typeof value.row_count !== 'number' ||
    typeof value.returned_rows !== 'number' ||
    typeof value.truncated !== 'boolean'
  ) {
    return null;
  }

  return {
    columns: value.columns,
    rows: value.rows,
    rowCount: value.row_count,
    returnedRows: value.returned_rows,
    truncated: value.truncated,
  };
};

export const isWarehouseQueryRejected = (invocation: Invocation): boolean =>
  invocation.result?.result.errorKind === 'user_rejected';
